// Cập nhật file: src/components/BottomNavigation.js
// Navigate đến màn notification thay vì callback

import React from 'react';
import { Calendar, FileText, Settings, Bell } from 'lucide-react';
import { SCREENS, USER_TYPES } from '../constants';

const BottomNavigation = ({ 
  activeScreen, 
  onNavigate, 
  onLogout, 
  userData, 
  notificationCount = 0 // NEW: Số lượng notification chưa đọc
}) => {
  
  const navigationItems = userData.type === USER_TYPES.DISPATCHER 
  ? [
    {
      id: SCREENS.REPORT,
      icon: FileText,
      label: 'Báo cáo',
      onClick: () => onNavigate(SCREENS.REPORT)
    },
    {
      id: SCREENS.NOTIFICATION, // Changed: Navigate to notification screen
      icon: Bell,
      label: 'Thông báo',
      onClick: () => onNavigate(SCREENS.NOTIFICATION),
      badge: notificationCount
    },
    {
      id: SCREENS.SETTINGS,
      icon: Settings,
      label: 'Cài đặt',
      onClick: () => onNavigate(SCREENS.SETTINGS)
    }
  ] : [
    // Navigation for DRIVER
    {
      id: SCREENS.CALENDAR,
      icon: Calendar,
      label: 'Lịch',
      onClick: () => onNavigate(SCREENS.CALENDAR)
    },
    {
      id: SCREENS.REPORT,
      icon: FileText,
      label: 'Báo cáo',
      onClick: () => onNavigate(SCREENS.REPORT)
    },
    {
      id: SCREENS.NOTIFICATION, // Changed: Navigate to notification screen
      icon: Bell,
      label: 'Thông báo',
      onClick: () => onNavigate(SCREENS.NOTIFICATION),
      badge: notificationCount
    },
    {
      id: SCREENS.SETTINGS,
      icon: Settings,
      label: 'Cài đặt',
      onClick: () => onNavigate(SCREENS.SETTINGS)
    }
  ];
  
  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 safe-area-bottom z-40">
      <div className="flex justify-around items-center py-2">
        {navigationItems.map((item) => {
          const Icon = item.icon;
          const isActive = activeScreen === item.id;
          const isNotification = item.id === SCREENS.NOTIFICATION;
          
          return (
            <button
              key={item.id}
              onClick={item.onClick}
              className={`relative flex flex-col items-center p-2 min-w-0 flex-1 ${
                isActive ? 'text-blue-600' : 'text-gray-600'
              } hover:text-blue-600 transition-colors`}
            >
              <div className="relative">
                <Icon className="w-6 h-6" />
                
                {/* Notification Badge */}
                {isNotification && item.badge > 0 && (
                  <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center font-bold">
                    {item.badge > 99 ? '99+' : item.badge}
                  </span>
                )}
              </div>
              
              <span className="text-xs mt-1 truncate">{item.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default BottomNavigation;
